'use client';

import { useMediaQuery as useMediaQueryBase } from 'usehooks-ts';

/**
 * Единая обёртка над usehooks-ts useMediaQuery с initializeWithValue:false.
 * На сервере и при ПЕРВОМ клиентском рендере всегда возвращает false, затем
 * обновляется после монтирования — это исключает рассинхрон гидратации SSR/CSR.
 * В отличие от react-responsive, который читает matchMedia сразу на первом
 * клиентском рендере и потому расходится с серверной разметкой.
 *
 * Используйте этот хук вместо react-responsive для любых медиазапросов.
 */
export function useMediaQuery(query: string): boolean {
  return useMediaQueryBase(query, { initializeWithValue: false });
}

export function useIsTabletOrDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)');
}
